import PaymentSettingsForm from '@/components/bot/PaymentSettingsForm'
import BotSettingsNavTabs from '@/components/bot/BotSettingsNavTabs'
import { Wallet } from 'lucide-react'

export default function PaymentSettingsPage() {
  return (
    <div className="p-4 sm:p-6 overflow-x-hidden min-h-screen bg-slate-50">
      <div className="mb-4 sm:mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#075E54]/10 rounded-xl flex items-center justify-center flex-shrink-0">
            <Wallet className="w-5 h-5 text-[#075E54]" />
          </div>
          <div>
            <h1 className="text-xl sm:text-2xl font-bold text-gray-900 leading-tight">Pagos</h1>
            <p className="text-xs sm:text-sm text-gray-600">
              Carga cómo cobra tu negocio y decide si el asistente puede enviar los datos bancarios al cliente.
            </p>
          </div>
        </div>
      </div>

      <BotSettingsNavTabs />

      <div className="bg-white rounded-2xl border border-slate-200/80 shadow-sm">
        <PaymentSettingsForm />
      </div>
    </div>
  )
}
